export default "__VITE_PUBLIC_ASSET__539d0b0b__"